import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Modal } from '../elements-modal/modal';
import CurrentDetailsContainer from '../app-main/containers/CurrentDetailsContainer';
import { initAuth } from '../app-main/actions/auth';
import { fetchAllFeeProfiles } from '../app-main/actions/feeProfile';
import { get } from 'lodash';

class CurrentDetailsIOSModal extends Component {
  constructor (props) {
    super(props);

    this.state = {
      whichModal: ''
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.scrollTopIOS = this.scrollTopIOS.bind(this);
  }

  componentDidMount () {
    const { dispatch, accessToken } = this.props;
    dispatch(initAuth(accessToken));
  }

  componentDidUpdate (prevProps) {
    const { dispatch, accessToken } = this.props;

    const hasFetched = get(this.props, 'profile.hasFetched', false);
    const prevHasFetched = get(prevProps, 'profile.hasFetched', false);

    if (hasFetched && !prevHasFetched) {
      const ssoId = get(this.props, 'profile.SSOid', '');
      dispatch(fetchAllFeeProfiles(accessToken, ssoId));
    }
  }

  closeModal () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  scrollTopIOS () {
    const modal = document.getElementById('current-details-modal');
    if (modal) {
      modal.scrollTo(0, 0);
    }
  }

  toggleModal (whichModal) {
    this.setState({ whichModal });
  }

  renderBody () {
    const { accessToken } = this.props;
    if (accessToken) {
    return (
        <CurrentDetailsContainer
          {...this.props}
          token={accessToken}
          closeIOSModal={this.closeModal}
          scrollTopIOS={this.scrollTopIOS}
          toggleModal={this.toggleModal}
          whichModal={this.state.whichModal}
          iosWebView
        />
      );
    }
  }

  render () {
    return (
      <Modal
        show
        addCloseIcon={false}
        modalID="current-details-modal"
        modalSize="lg-size"
        modalType="standard"
        body={this.renderBody()}
      />
    );
  }
}

CurrentDetailsIOSModal.propTypes = {
  accessToken: PropTypes.string,
  dispatch: PropTypes.func,
  reviewAction: PropTypes.string,
  reviewBooking: PropTypes.bool
};

function mapStateToProps (state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(CurrentDetailsIOSModal)
